module.exports = __webpack_public_path__ + "img/banner-telesalud2.1e5e8e70.png";